module.exports = __webpack_public_path__ + "img/delicious-preservative-foods@1x.57f411c1.png";